import { MapViewMarker } from "@msuite/ui/map";

export function TargetPin() {
	return (
		<MapViewMarker
			iconName="Target"
			color="var(--color-orange-500)"
		/>
	);
}
